import { SUPPORTED_LOCALES } from '@runtime/core/i18n/localeConfig'

export function homeDestinations(locale: string) {
  const language = SUPPORTED_LOCALES.find(value => value === locale) || 'fr'
  return {
    workshops: `https://www.united-square.com/${language}/${language === 'fr' ? 'ateliers' : 'workshops'}`,
    universe: `https://www.united-square.com/${language}`,
    language,
    fallback: locale !== language,
  }
}
